import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  considerWorker,
  unconsiderWorker,
} from '@company/services/application/api';
import QueryKeys from '@constants/queryKeys';

export function useConsiderCandidate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      jobId,
      workerId,
      consider,
    }: {
      jobId: number;
      workerId: number;
      consider: boolean;
    }) =>
      consider
        ? considerWorker(jobId, workerId)
        : unconsiderWorker(jobId, workerId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.JobDetail.CANDIDATES],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.JobDetail.CANDIDATE_COUNTERS],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.COMPANY_JOB_COUNTERS],
      });
    },
  });
}
